import PropTypes from 'prop-types';
import AdvisorInfo from '../../MediaShare/components/AdvisorInfo';
import OfficeContactInfo from '../../MediaShare/components/OfficeContactInfo';
import {publicOfficeInfoShape, publicUserInfoShape} from '_app/shapes';
import './pageFooter.less';

const PageFooter = ({userInfo, office, token, isCampaign}) => {
	return (
		<div className= {isCampaign ? 'campaign-footer' : 'footer page-footer hidden-print'} >
			<div className="container legacy-container">
				{office.isFirmBrandingEnabled && <OfficeContactInfo office={office} />}
				<div className="row">
					<div className="col-sm-3">
						{!office.isFirmBrandingEnabled && <AdvisorInfo userInfo={userInfo} />}
					</div>
					<div className="col-sm-6">
						<div className="text-center">
							{userInfo && <ul className="list-inline list-inline-bullets">
								{userInfo.disclaimers && userInfo.disclaimers.map(disclaimer => (
									<li key={'legalLink-' + disclaimer.key}>
										<a
											href={`/ABM/MediaServe/Legal?contentId=${disclaimer.key}&token=${token}&isCampaign=${isCampaign}`}
											className="small"
										>
											{disclaimer.value}
										</a>
									</li>
								))}
							</ul>}
						</div>
						<div className="text-center small">
							<ul className="list-inline list-inline-bullets">
								<li>&copy; {new Date().getFullYear()} eMoney Advisor, LLC</li>
								<li>Software version {ABM_VERSION}</li>
							</ul>
						</div>
					</div>
					<div className="col-sm-3">&nbsp;</div>
				</div>
			</div>
		</div>
	);
};

PageFooter.propTypes = {
	userInfo: publicUserInfoShape,
	office: publicOfficeInfoShape,
	token: PropTypes.string
};

export default PageFooter;